<template>
    <div class="data-input select-field sorting" style="">
        <div class="select-container">
            <select v-model="orderBy" v-on:change="$emit('input', orderBy)">
                <option value="id,desc">{{ $t('sort.newest-first') }}</option>
                <option value="id,asc">{{ $t('sort.oldest-first') }}</option>
                <option value="property.address,asc">{{ $t('sort.address-ascending') }}</option>
                <option value="property.zip_code,asc">{{ $t('sort.zipcode-ascending') }}</option>
<!--                <option value="tenant,asc">{{ $t('sort.tenant-ascending') }}</option>-->
            </select>
            <span class="arrow"><SvgIcon icon="sort-icon"/></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractFilter",
    data() {
        return {
            orderBy: 'id,desc'
        }
    }
}
</script>

<style scoped>

</style>
